import React from 'react'

const EstimatedPriceEntryContent = () => (
  <>
    <section className="text-white bg-brand-fuchsia body-font">
      <div className="relative px-5 pb-4 mx-auto h-28">
        <div className="flex justify-center pt-5 md:pt-0 md:justify-start md:absolute left-8 top-5">
          <img src="/images/Logo.svg" alt="autoverkaufen.de" />
        </div>
      </div>
    </section>

    <section className="text-white bg-brand-fuchsia body-font">
      <div className="relative px-5 mx-auto mt-14">
        <div className="grid items-end grid-cols-4 gap-1 mt-3">
          <div className="col-span-4 mb-10 md:col-span-2">
            <h3 className="mr-6 text-3xl font-bold text-center md:text-right">
              Verkauf dein Auto <br className="hidden md:block" />
              mit <span className="text-brand-lime">autoverkaufen.de</span>
            </h3>
            <p className="mt-2 mr-6 text-lg text-center md:text-right">Jetzt kostenlos bewerten und Bestpreis sichern!</p>
          </div>
          <div className="col-span-4 md:col-span-2">
            <div className="relative">
              <div className="relative inset-0 pb-10 md:absolute md:-top-44">
                <div className="w-full max-w-full p-4 bg-brand-lime md:max-w-md min-h-[24rem] rounded-3xl">
                  <form className="text-gray-800">
                    <div className="px-4 py-2 bg-white rounded-3xl">
                      <div className="w-2/3 pb-0">Lorem ipsum dolor sit amet, consetetur sadipscing</div>
                      <div className="box-border h-24">
                        <img
                          src="https://uploads-ssl.webflow.com/60dd7cb9f8a8902ddf2cf86e/60e801569ce03346c8dcd4f7_progress_1.png"
                          loading="lazy"
                          alt=""
                          className="box-border hidden max-w-full align-middle border-0"
                        />
                        <img
                          src="https://uploads-ssl.webflow.com/60dd7cb9f8a8902ddf2cf86e/60e8017cf334141fb183014c_progress_2.png"
                          loading="lazy"
                          alt=""
                          className="box-border hidden max-w-full pt-0 -mt-4 align-middle border-0"
                        />
                        <img
                          src="https://uploads-ssl.webflow.com/60dd7cb9f8a8902ddf2cf86e/60e8017c3268aa3cd48085d1_progress_3.png"
                          loading="lazy"
                          alt=""
                          className="box-border block max-w-full align-middle border-0"
                        />
                        <img
                          src="https://uploads-ssl.webflow.com/60dd7cb9f8a8902ddf2cf86e/60e8017c96409317215b4912_progress_4.png"
                          loading="lazy"
                          alt=""
                          className="box-border hidden max-w-full align-middle border-0"
                        />
                        <img
                          src="https://uploads-ssl.webflow.com/60dd7cb9f8a8902ddf2cf86e/60e8017cfa691c24a1505f9e_progress_5.png"
                          loading="lazy"
                          alt=""
                          className="box-border hidden max-w-full align-middle border-0"
                        />
                        <img
                          src="https://uploads-ssl.webflow.com/60dd7cb9f8a8902ddf2cf86e/60e8017ce3fb2e3f8d8ed419_progress_6.png"
                          loading="lazy"
                          alt=""
                          className="box-border hidden max-w-full align-middle border-0"
                        />
                        <img
                          src="https://uploads-ssl.webflow.com/60dd7cb9f8a8902ddf2cf86e/60e8017dd2c2b2e73ab283ff_progress_7.png"
                          loading="lazy"
                          alt=""
                          className="box-border hidden max-w-full align-middle border-0"
                        />
                        <img
                          src="https://uploads-ssl.webflow.com/60dd7cb9f8a8902ddf2cf86e/60e8017d1ad1954b42b0b9ae_progress_8.png"
                          loading="lazy"
                          alt=""
                          className="box-border hidden max-w-full align-middle border-0"
                        />
                        <img
                          src="https://uploads-ssl.webflow.com/60dd7cb9f8a8902ddf2cf86e/60e8017dd7cc71d0d0ff1a59_progress_9.png"
                          loading="lazy"
                          alt=""
                          className="box-border hidden max-w-full align-middle border-0"
                        />
                      </div>
                    </div>

                    <select className="w-full h-8 leading-4 bg-white border-2 appearance-none rounded-2xl py-0.5 px-3 mx-0 my-2 focus:border-blue-500">
                      <option value="0">Marke</option>
                      <option value="audi">Audi</option>
                    </select>

                    <select className="w-full h-8 leading-4 bg-white border-2 appearance-none rounded-2xl py-0.5 px-3 mx-0 my-2 focus:border-blue-500">
                      <option value="0">Modell</option>
                      <option value="A1">A1</option>
                      <option value="A2">A2</option>
                      <option value="A3">A3</option>
                      <option value="A4">A4</option>
                      <option value="A5">A5</option>
                      <option value="A6">A6</option>
                    </select>

                    <select
                      id="year"
                      name="year"
                      required
                      className="w-full h-8 leading-4 bg-white border-2 appearance-none rounded-2xl py-0.5 px-3 mx-0 my-2 focus:border-blue-500"
                    >
                      <option value="0">Jahr der Erstzulassung</option>
                      <option value="2021">2021</option>
                      <option value="2020">2020</option>
                      <option value="2019">2019</option>
                      <option value="2018">2018</option>
                      <option value="2017">2017</option>
                      <option value="2016">2016</option>
                    </select>

                    <select className="w-full h-8 leading-4 bg-white border-2 appearance-none rounded-2xl py-0.5 px-3 mx-0 my-2 focus:border-blue-500">
                      <option value="0">Fahrzeugkategorie</option>
                      <option value="Cabrio/Roadster">Cabrio/Roadster</option>
                      <option value="Kombi">Kombi</option>
                      <option value="SUV/Gelaendewagen/Pickup">SUV/Gelaendewagen/Pickup</option>
                      <option value="Kleinwagen">Kleinwagen</option>
                      <option value="Sportwagen/Coupe">Sportwagen/Coupe</option>
                      <option value="Van/Kleinbus">Van/Kleinbus</option>
                    </select>

                    <select className="w-full h-8 leading-4 bg-white border-2 appearance-none rounded-2xl py-0.5 px-3 mx-0 my-2 focus:border-blue-500">
                      <option value="0">Motorvariante</option>
                      <option value="1">1.6 CDi</option>
                      <option value="2">1.7 CDi</option>
                      <option value="3">1.8 TDi</option>
                      <option value="4">1.9 TDi</option>
                      <option value="5">2.0 CDi</option>
                      <option value="6">2.4i / 121 kW V6</option>
                    </select>

                    <select className="w-full h-8 leading-4 bg-white border-2 appearance-none rounded-2xl py-0.5 px-3 mx-0 my-2 focus:border-blue-500">
                      <option value="0">Getriebe</option>
                      <option value="1">Automatik 7 Gang</option>
                      <option value="2">Automatik TipTronic</option>
                      <option value="3">Manuell 6 Gang</option>
                    </select>

                    <select className="w-full h-8 leading-4 bg-white border-2 appearance-none rounded-2xl py-0.5 px-3 mx-0 my-2 focus:border-blue-500">
                      <option value="0">Typ</option>
                      <option value="1">S-Line</option>
                      <option value="2">R-Line</option>
                    </select>

                    <input
                      type="text"
                      className="w-full h-8 leading-4 bg-white border-2 appearance-none rounded-2xl py-0.5 px-3 mx-0 my-2 focus:border-blue-500"
                      maxLength={256}
                      name="mileage"
                      data-name="mileage"
                      placeholder="Kilometerstand"
                      id="mileage"
                      required
                    />
                    <input
                      type="text"
                      className="w-full h-8 leading-4 bg-white border-2 appearance-none rounded-2xl py-0.5 px-3 mx-0 my-2 focus:border-blue-500"
                      maxLength={256}
                      name="mail"
                      data-name="mail"
                      placeholder="E-Mail"
                      id="mail"
                      required
                    />

                    <div className="box-border">
                      <div className="box-border relative">
                        <label
                          className="box-border table clear-both pl-5 mb-2 cursor-default"
                          style={{ fontWeight: 'bold', gridArea: '1 / 1 / 2 / 2' }}
                        >
                          <div
                            className="box-border absolute w-5 h-5 mt-px font-bold bg-white"
                            style={{ inset: '0% auto auto 0%', borderRadius: '16px' }}
                          >
                            <div className="box-border w-3 h-3 mt-1 mb-0 ml-1 mr-0 bg-blue-500 rounded-3xl"></div>
                          </div>
                          <input
                            type="checkbox"
                            id="sendmail"
                            name="sendmail"
                            data-name="sendmail"
                            className="box-border static float-left p-0 mt-px mb-0 mr-0 -ml-5 font-bold border border-black border-none rounded-none opacity-0 bg-clip-border"
                            style={{ lineHeight: 'normal', textIndent: '-1000px' }}
                          />
                          <span
                            htmlFor="sendmail"
                            className="box-border inline-block pl-4 mb-0 text-xs font-normal opacity-50 cursor-pointer agb-consent"
                            style={{ lineHeight: 1.1 }}
                          >
                            Ich bin mit dem Erhalt der Bewertung per E-Mail einvertanden.
                            <br className="box-border leading-3" />
                            Mit Anforderung der Online-Bewertung erklaerst du dich mit den AGBs und der Datenschutzerklaerung einverstanden.
                          </span>
                        </label>
                      </div>
                      <div className="box-border relative">
                        <div
                          className="box-border absolute w-5 h-5 mt-px bg-white rounded-3xl"
                          style={{ inset: '0% auto auto 0%' }}
                        >
                          <div className="box-border w-3 h-3 mt-1 mb-0 ml-1 mr-0 bg-blue-500 rounded-3xl"></div>
                        </div>
                        <label
                          className="box-border table clear-both pl-5 mb-2 cursor-default"
                          style={{ fontWeight: 'bold', gridArea: '1 / 1 / 2 / 2' }}
                        >
                          <input
                            type="checkbox"
                            id="newsletter"
                            data-name="newsletter"
                            name="newsletter"
                            className="box-border static float-left p-0 mt-px mb-0 mr-0 -ml-5 font-bold border border-black border-none rounded-none opacity-0 bg-clip-border"
                            style={{ lineHeight: 'normal', textIndent: '-1000px' }}
                          />
                          <span
                            htmlFor="newsletter"
                            className="box-border inline-block pl-4 mb-0 text-xs font-normal opacity-50 cursor-pointer agb-consent"
                            style={{ lineHeight: 1.1 }}
                          >
                            Ich moechte den Newsletter erhalten
                          </span>
                        </label>
                      </div>
                    </div>

                    <div className="flex items-center">
                      <a
                        href="/src/estimated-price-result.html"
                        className="box-border relative w-full h-8 px-5 py-1 my-0 font-bold text-center text-white no-underline bg-blue-300 border-0 cursor-not-allowed hover:text-white hover:bg-blue-700"
                        style={{ transition: 'color 200ms ease-in-out 0s', borderRadius: '16px' }}
                      >
                        Jetzt Schätzpreis erhalten!
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="bg-brand-fuchsia body-font">
      <img
        src="/images-optimized/BG_Eingabe.jpg"
        loading="lazy"
        sizes="100vw"
        alt="Verkauf dein Auto mit autoverkaufen.de"
        className="box-border inline-block object-fill w-screen overflow-hidden leading-6 text-gray-900 align-middle border-0"
        style={{ maxWidth: '100vw' }}
      />
    </section>
  </>
)

export default EstimatedPriceEntryContent
